import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { CaseDrawer } from "@/components/kanban/CaseDrawer";
import type { Case } from "@/lib/useRealtimeCases";
export default function ReminderCasePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [row, setRow] = useState<Case | null>(null),
    [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    setRow(null);
    setError("");
    void supabase
      .from("cases")
      .select("*")
      .eq("id", id!)
      .single()
      .then(({ data, error }) => {
        if (!alive) return;
        if (error) setError("Ce dossier n’est plus accessible.");
        else setRow(data);
      });
    return () => {
      alive = false;
    };
  }, [id]);
  return (
    <>
      <div className="p-8 text-sm text-gray-500">
        {error || "Ouverture du dossier associé à votre rappel…"}
        {error && (
          <button className="ml-3 underline" onClick={() => navigate("/kanban")}>
            Revenir au Kanban
          </button>
        )}
      </div>
      {row && <CaseDrawer case={row} onClose={() => navigate("/kanban")} />}
    </>
  );
}
